import {NullableKeys, TripleAttributeValue} from '@fl/cmsch-fe-library';

import {CorrectionType} from 'api/gen/CorrectionType';
import {Date} from 'api/gen/Date';

/** Redux-form identifier for the analysis protocol correction form. */
export const apcReportFormName = 'apcReport';

/** Public form value shape for creating or editing an analysis protocol correction report. */
export type ApcReportFormValues = NullableKeys<{
    correctionType: CorrectionType,
    technicianNumber: string,
    earTag: string,
    stableNumber: string,
    proficiencyTestDate: Date,
    updatedEarTag: string,
    milkingTripleAttribute: TripleAttributeValue,
    milkKg: number,
    fatPercentage: number,
    proteinPercentage: number,
    lactosePercentage: number,
    somaticCells: number,
    urea: number,
}>;

/** Default form values for a new correction report session. */
export const initialApcReportFormValues: ApcReportFormValues = {
    correctionType: 'UPDATE',
    technicianNumber: null,
    earTag: null,
    stableNumber: null,
    proficiencyTestDate: null,
    updatedEarTag: null,
    milkingTripleAttribute: null,
    milkKg: null,
    fatPercentage: null,
    proteinPercentage: null,
    lactosePercentage: null,
    somaticCells: null,
    urea: null,
};
